import type { APIClient } from "@heidelbergmaterials/fcl-apiclient"

import { PaginationRequest } from "../types"
import { CycleViewData, Cycle, ChangeCycleStatus, TotalDeposits } from "./types"

export const getCycleShortViewData = (
	apiClient: APIClient,
	plantNumber: string,
	pagination: PaginationRequest,
): Promise<CycleViewData> =>
	apiClient
		.get("/cycles", {
			params: {
				plantNumber,
				...pagination,
			},
		})
		.then(response => response.data)

export const getCycleById = (
	apiClient: APIClient,
	id: string,
): Promise<Cycle> =>
	apiClient.get(`/cycles/${id}`).then(response => response.data)

export const changeCycleStatus = (
	apiClient: APIClient,
	cycle: string,
	data: ChangeCycleStatus,
): Promise<void> => apiClient.patch(`/cycles/${cycle}`, data).then(() => {})

export const getTotalDeposits = (
	apiClient: APIClient,
): Promise<TotalDeposits> =>
	apiClient.get("/cycles/total-deposits").then(response => response.data)
